import { Component, HostBinding, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { INavLink } from '@pw-layout/interfaces/router-link.interface';
import { INavTabOptions } from '../../interfaces/nav-tab-options.interface';

@Component({
  selector: 'pw-nav-tab',
  templateUrl: './nav-tab.component.html',
  styleUrls: ['./nav-tab.component.scss'],
})
export class NavTabComponent {
  @HostBinding('class.active')
  public get active(): boolean {
    const urlCommand = this.navLink?.link instanceof Array ? this.navLink.link : [this.navLink?.link];
    const navExtras = { relativeTo: this._route, queryParams: this.navLink?.queryParams };
    const urlTree = this._router.createUrlTree(urlCommand, navExtras);
    return this._router.isActive(urlTree, this.options.exact);
  }

  @Input() public navLink: INavLink;
  @Input() public badge: number;
  private _defaultOption: INavTabOptions = {
    replaceUrl: false,
    exact: false,
  };

  private _options: INavTabOptions = this._defaultOption;

  public get options(): Partial<INavTabOptions> {
    return this._options;
  }

  @Input()
  public set options(value: Partial<INavTabOptions>) {
    this._options = { ...this._defaultOption, ...value };
  }

  constructor(private _router: Router, private _route: ActivatedRoute) {}
}
